import classNames from 'classnames/bind'
import styles from './EFExpandSearch.module.scss'

import { ChangeEvent, FormEvent, useRef, useState } from 'react'
import { useClickOutside } from '~/hooks'
import { currentTheme } from '~/redux/features'
import { useAppSelector } from '~/app/hooks'
import { EFIconButton } from '../EFStyledComponents'
import { SearchInputProps } from './EFExpandSearch.model'
import { SearchIcon } from '../EFIcons'

const cx = classNames.bind(styles)

export function EFExpandSearch({ onSubmit, placeHolder = 'Search' }: SearchInputProps) {
  const searchBoxRef = useRef<HTMLDivElement>(null)
  const [isExtended, setIsExtended] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const theme = useAppSelector(currentTheme)

  useClickOutside(searchBoxRef, () => setIsExtended(false))

  function handelChangeSearchTerm(event: ChangeEvent<HTMLInputElement>) {
    setSearchTerm(event.target.value)
  }

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    onSubmit(searchTerm)
  }

  function handleClickButton() {
    if (isExtended) {
      onSubmit(searchTerm)
    } else {
      setIsExtended(true)
    }
  }
  return (
    <div
      className={cx('search-container')}
      ref={searchBoxRef}
    >
      <form onSubmit={handleSubmit}>
        <input
          className={cx('search', isExtended ? 'expandright' : '', theme)}
          id='searchright'
          type='search'
          placeholder={placeHolder}
          value={searchTerm}
          autoComplete='off'
          onChange={handelChangeSearchTerm}
        />
        <EFIconButton
          id='btn-search-toolbar'
          className={cx('button', 'searchbutton')}
          onClick={handleClickButton}
        >
          <label
            htmlFor='searchright'
            className={cx('pointer', 'search-label')}
          >
            <SearchIcon />
          </label>
        </EFIconButton>
      </form>
    </div>
  )
}
